"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _PriceTiers = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/PriceTiers"));

var _ContactsSelectors = require("pricing-pages-unified-ui/selectors/ContactsSelectors");

var _CurrencySelector = _interopRequireDefault(require("pricing-pages-unified-ui/components/contacts-confirmation-page/traditional-hub/CurrencySelector"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 60px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// This is needed to apply a style to the dialog instead of the modal
var ModalDialogWrapper = function ModalDialogWrapper(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_UIModal.default, (0, _extends2.default)({
    dialogClassName: className
  }, rest));
};

var StyledModal = (0, _styledComponents.default)(ModalDialogWrapper).withConfig({
  displayName: "ContactPriceBreakdownModal__StyledModal",
  componentId: "sc-14z40zh-0"
})(_templateObject());

var ContactsPriceBreakdownModal = function ContactsPriceBreakdownModal(_ref2) {
  var _headerLangMapMC;

  var numContactsInCrm = _ref2.numContactsInCrm,
      handleModalClose = _ref2.handleModalClose,
      merchandiseId = _ref2.merchandiseId,
      marketingContactsSelected = _ref2.marketingContactsSelected,
      termId = _ref2.termId;
  var isMarketingContacts = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MarketingContactsSelectors.isMarketingContactsSKUSelector)(state, merchandiseId);
  });

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.baseMerchForAdditionalUnitSelector)(state, merchandiseId);
  }),
      edition = _useSelector.edition;

  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var headerLangMapMC = (_headerLangMapMC = {}, (0, _defineProperty2.default)(_headerLangMapMC, Editions.STARTER, 'contactTierPricingModal.marketingContacts.marketingHubStarter'), (0, _defineProperty2.default)(_headerLangMapMC, Editions.PROFESSIONAL, 'contactTierPricingModal.marketingContacts.marketingHubProfessional'), (0, _defineProperty2.default)(_headerLangMapMC, Editions.ENTERPRISE, 'contactTierPricingModal.marketingContacts.marketingHubEnterprise'), _headerLangMapMC);
  var headerLangKeyMC = headerLangMapMC[edition];
  return _react.default.createElement(StyledModal, {
    width: 600,
    use: "conversational"
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: handleModalClose
  })), _react.default.createElement(_UIDialogBody.default, null, isMarketingContacts && _react.default.createElement(_H2.default, {
    className: "m-bottom-3"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: headerLangKeyMC
  })), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: isMarketingContacts ? 'contactTierPricingModal.marketingContacts.header' : 'contactTierPricingModal.modalTitle'
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: isMarketingContacts ? 'contactTierPricingModal.marketingContacts.description' : 'contactTierPricingModal.modalDescription'
  })), !isMarketingContacts && _react.default.createElement(_EnvironmentWrapper.default, {
    authedNode: _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "contactTierPricingModal.currentContactsInCrm",
      options: {
        contacts: numContactsInCrm
      }
    }))
  }), _react.default.createElement("div", {
    className: "text-right"
  }, _react.default.createElement(_CurrencySelector.default, null)), _react.default.createElement(_PriceTiers.default, {
    merchandiseId: merchandiseId,
    currencyCode: currencyCode,
    edition: edition,
    marketingContactsSelected: marketingContactsSelected,
    termId: termId
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    numContactsInCrm: (0, _ContactsSelectors.numContactsInCrmSelector)(state)
  };
};

ContactsPriceBreakdownModal.propTypes = {
  numContactsInCrm: _propTypes.default.number,
  handleModalClose: _propTypes.default.func,
  merchandiseId: _propTypes.default.number.isRequired,
  marketingContactsSelected: _propTypes.default.number,
  termId: _propTypes.default.number
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ContactsPriceBreakdownModal);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/contacts-price-breakdown/ContactPriceBreakdownModal.js
// module id = 357
// module chunks = 5 6